import { Component, Input, OnInit } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TerceroService } from '../../_services/tercero.service';
import { forkJoin } from 'rxjs';
import { Tercero } from '../../_models/tercero';
import { ConstanteService } from '../../_services/constante.service';
import { TipoTerceroClasificacionService } from '../../_services/tipo-tercero-clasificacion.service';
import { TerceroTipoClasificacionService } from '../../_services/tercero-tipo-clasificacion.service';
import { Location } from '@angular/common';
import { AliadoSucursal } from '../../_models/aliado-sucursal';
import { AliadoSucursalService } from '../../_services/aliado-sucursal.service';
import { Aliado } from '../../_models/aliado';
import { AliadoService } from '../../_services/aliado.service';
import { ConfirmationService } from 'primeng/api';

@Component( {
  selector: 'app-aliados-sucursales-listado',
  templateUrl: 'aliados-sucursales-listado.component.html'
} )

export class AliadosSucursalesListadoComponent implements OnInit {

  esDetalle: boolean;
  carInformacionInicial = true;
  tercero: Tercero;
  sucursales: AliadoSucursal[] = [];
  columnas: any = [];
  carTabla = false;
  busqueda: string;
  aliado: Aliado;
  actAliado = false;
  indHabilitadoAliado: boolean;

  constructor( private navServicio: NavService,
               private sucService: AliadoSucursalService,
               private route: ActivatedRoute,
               private conServicio: ConstanteService,
               private claTiposTercerosServicio: TipoTerceroClasificacionService,
               private router: Router,
               private terTipoClasificacionServicio: TerceroTipoClasificacionService,
               private location: Location,
               private aliServicio: AliadoService,
               private serConfirmacionServicio: ConfirmationService,
               private terServicio: TerceroService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_NOMBRE' ), sort: true },
      {
        field: 'descripcionDivisionPolitica',
        header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_UBICACION' ),
        sort: true
      },
      { field: 'alias', header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_ALIAS' ), sort: true },
      {
        field: 'nombreEstructuraFisica',
        header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_ESTRUCTURAFISICA' ),
        sort: true
      },
      {
        field: 'cantidadUsuarios',
        header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_CANTIDADUSUARIOS' ),
        sort: true
      },
      { field: 'cupoValor', header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_CUPOVALOR' ), sort: true },
      { field: 'cupoCredito', header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_CUPOCREDITO' ), sort: true },
      {
        field: 'indicadorPrincipal',
        header: this.navServicio.buscarMensaje( 'SUCURSALES.LBL_PRINCIPAL' ),
        sort: false
      },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      this.esDetalle = this.route.snapshot.data[ 'detalle' ] ? true : false;
      forkJoin(
        this.aliServicio.obtenerPorId( params[ 'id' ] ),
        this.sucService.obtenerPorAliado( params[ 'id' ] )
      ).subscribe( ( [ aliado, aliUsuarios ] ) => {
        this.aliado = aliado;
        this.indHabilitadoAliado = this.aliado.indicadorHabilitado;
        this.sucursales = aliUsuarios;
        this.terServicio.get( this.aliado.idTercero ).subscribe( ter => {
          this.tercero = ter;
          this.cargarConstante();
        } );
      } );
    } );
  }

  cargarConstante() {
    this.conServicio.getByCode( 'DINALI' ).subscribe( constante => {
      if ( constante && constante.valor && constante.valor.length > 0 ) {
        const tipClasificacionTercero = constante.valor.split( ';' );
        if ( tipClasificacionTercero.length > 1 ) {
          this.claTiposTercerosServicio.getByCode( tipClasificacionTercero[ 1 ] ).subscribe( clasificacion => {
            if ( clasificacion.codigoTerceroTipo === tipClasificacionTercero[ 0 ] ) {
              this.verificarTiposTercero( clasificacion.idTerceroTipoClasificacion );
            } else {
              this.navServicio.setMesage( 4, {
                severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
                detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_CONFIGURADAERRONEA' )
              } );
              this.router.navigate( [ 'apl/aliados' ] );
            }
          }, error => {
            this.navServicio.setMesage( 4, {
              severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
              detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_CONFIGURADAERRONEA' )
            } );
            this.router.navigate( [ 'apl/aliados' ] );
          } );
        } else {
          this.navServicio.setMesage( 4, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
            detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_CONFIGURADAERRONEA' )
          } );
          this.router.navigate( [ 'apl/aliados' ] );
        }
      } else {
        this.navServicio.setMesage( 4, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
          detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_NOCONFIGURADA' )
        } );
        this.router.navigate( [ 'apl/aliados' ] );
      }
    }, error => {
      this.navServicio.setMesage( 4, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
        detail: this.navServicio.buscarMensaje( 'CONSTANTES.MSG_NOEXISTE' )
      } );
      this.router.navigate( [ 'apl/aliados' ] );
    } );
  }

  verificarTiposTercero( idTerceroClasificacion: string ) {
    this.terTipoClasificacionServicio.obtenerPorClasificacionPorTercero( this.tercero.idTercero, idTerceroClasificacion ).subscribe( terTipo => {
      if ( terTipo ) {
        this.carInformacionInicial = false;
      } else {
        this.navServicio.setMesage( 4, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
          detail: this.navServicio.buscarMensaje( 'TERCERO.MSG_NOTIENECLASIFICACION' )
        } );
        this.router.navigate( [ 'apl/aliados' ] );
      }
    } );
  }

  crearSucursal() {
    this.router.navigate( [ 'apl/aliados/sucursales/' + this.aliado.idAliado + '/agregar' ] );
  }

  verSucursal( sucursal: AliadoSucursal ) {
    this.router.navigate( [ 'apl/aliados/sucursales/' + this.aliado.idAliado + '/detalle/' + sucursal.idAliadoSucursal + (this.esDetalle ? '/todo' : '') ] );
  }

  editarSucursal( sucursal: AliadoSucursal ) {
    this.router.navigate( [ 'apl/aliados/sucursales/' + this.aliado.idAliado + '/actualizar/' + sucursal.idAliadoSucursal ] );
  }

  cambioHabilitadoAliado() {
    this.actAliado = true;
    this.serConfirmacionServicio.confirm( {
      message: this.navServicio.buscarMensaje( this.indHabilitadoAliado ? 'SUCURSALES.MSG_HABILITAR' : 'SUCURSALES.MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'aliado-sucursal',
      accept: () => {
        if ( this.indHabilitadoAliado ) {
          this.actualizarAliado();
        } else {
          this.aliServicio.validarHabilitar( this.aliado.idAliado ).subscribe( l => {
            if ( l && l.estado ) {
              this.actualizarAliado();
            } else {
              this.indHabilitadoAliado = !this.indHabilitadoAliado;
              this.actAliado = false;
              this.navServicio.setMesage( 4, {
                severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'SUCURSALES.MSG_NOSEPUEDEINHABILITAR' )
              } );
            }
          } );
        }
      },
      reject: () => {
        this.indHabilitadoAliado = !this.indHabilitadoAliado;
        this.actAliado = false;
      }
    } );
  }

  actualizarAliado() {
    this.aliado.indicadorHabilitado = this.indHabilitadoAliado;
    this.aliServicio.actualizar( this.aliado ).subscribe( r => {
      this.actAliado = false;
      this.navServicio.setMesage( 2 );
    } );
  }

  regresar() {
    this.router.navigate( [ 'apl/aliados' ] );
  }


}
